import React from 'react';
import { ShoppingCartIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="w-full bg-cream-dark py-24 px-4 text-center" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <h2 className="text-3xl md:text-4xl font-bold text-brown-primary mb-12 font-serif" data-id="element-13">
          Tienes dos caminos hoy:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 text-left" data-id="element-14">
          <div className="bg-white p-8 rounded-xl border-t-4 border-brown-secondary/30 shadow-md" data-id="element-15">
            <h3 className="text-xl font-bold text-brown-primary mb-4 font-serif" data-id="element-16">
              Camino A
            </h3>
            <p className="text-brown-secondary leading-relaxed" data-id="element-17">
              Seguir comprando cremas de $800 o $1,500 pesos por "corazonada",
              esperando que esta vez sí funcionen, mientras tu cajón se sigue
              llenando de dinero tirado.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl border-t-4 border-rose-gold shadow-md" data-id="element-18">
            <h3 className="text-xl font-bold text-rose-gold mb-4 font-serif" data-id="element-19">
              Camino B (El inteligente)
            </h3>
            <p className="text-brown-secondary leading-relaxed" data-id="element-20">
              Invertir $9 dólares (lo que te gastas en un combo de comida rápida
              o dos cafés de sirena) para tener el mapa definitivo que te
              ahorrará miles de pesos de por vida.
            </p>
          </div>
        </div>

        <p className="text-2xl font-serif italic text-brown-primary mb-10" data-id="element-21">
          Es hora de dejar de adivinar y empezar a ver resultados.
        </p>

        <a href="#precio" className="w-full md:w-auto px-8 md:px-12 py-5 bg-rose-gold hover:bg-rose-dark text-white text-lg md:text-xl font-bold tracking-wide rounded-sm transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 inline-flex items-center justify-center gap-3 mb-6" data-id="element-22">
          <ShoppingCartIcon className="w-6 h-6" data-id="element-23" />
          SÍ, QUIERO MI PIEL DE VIDRIO POR $9 USD
        </a>

        <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-brown-secondary/80 font-medium" data-id="element-24">
          <span data-id="element-25">Acceso inmediato</span>
          <span className="hidden sm:inline" data-id="element-26">•</span>
          <span data-id="element-27">Formato PDF + Audio</span>
          <span className="hidden sm:inline" data-id="element-28">•</span>
          <span data-id="element-29">Pago Seguro con Hotmart</span>
        </div>
      </div>
    </section>;
}